import { searchRetryConfig } from '@/lib/http/searchRequests';

import kinetikApi from './kinetikAPI';

export default {
  getProviderRates: (orgResourceId, contractUuid, options) =>
    kinetikApi
      .get(`/${orgResourceId}/contracts/c/${contractUuid}/rates`, {
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  postProviderRate: (orgResourceId, contractUuid, rate) =>
    kinetikApi
      .post(`/${orgResourceId}/contracts/c/${contractUuid}/rates`, rate, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  deleteProviderRate: (orgResourceId, contractUuid, rateUuid) =>
    kinetikApi
      .delete(
        `/${orgResourceId}/contracts/c/${contractUuid}/rates/r/${rateUuid}`,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  deleteProviderInvoicedRate: (orgResourceId, contractUuid, mappingUuid) =>
    kinetikApi
      .delete(
        `/${orgResourceId}/contracts/c/${contractUuid}/quoted-fare-to-line-items-mappings/m/${mappingUuid}`,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  duplicateProviderRates: (
    orgResourceId,
    contractUuid,
    targetRegionUuid,
    payload,
  ) =>
    kinetikApi
      .post(
        `/${orgResourceId}/contracts/c/${contractUuid}/rates/duplicate-to/region/${targetRegionUuid}`,
        payload,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  getProviderInvoicedRates: (orgResourceId, contractUuid, options) =>
    kinetikApi
      .get(
        `/${orgResourceId}/contracts/c/${contractUuid}/quoted-fare-to-line-items-mappings`,
        { ...options, serviceName: 'trip' },
      )
      .then((res) => res.data),
  createProviderInvoicedRate: (orgResourceId, contractUuid, invoicedRate) =>
    kinetikApi
      .post(
        `/${orgResourceId}/contracts/c/${contractUuid}/quoted-fare-to-line-items-mappings`,
        invoicedRate,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  getProviderRegions: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/contracts`, { ...options, serviceName: 'trip' })
      .then((res) => res.data),
  postProviderContract: (orgResourceId, contractType, payload) =>
    kinetikApi
      .post(`/${orgResourceId}/contracts/${contractType}`, payload, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  updateProviderContract: (orgResourceId, contractUuid, payload) =>
    kinetikApi
      .patch(`/${orgResourceId}/contracts/c/${contractUuid}`, payload, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  addToContract: (orgResourceId, contractUuid, payload) =>
    kinetikApi
      .patch(`/${orgResourceId}/contracts/c/${contractUuid}/add`, payload, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  deleteRegion: (orgResourceId, contractUuid, regionUuid) =>
    kinetikApi
      .delete(
        `/${orgResourceId}/contracts/c/${contractUuid}/regions/r/${regionUuid}`,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  deleteLos: (orgResourceId, contractUuid, losUuid) =>
    kinetikApi
      .delete(
        `/${orgResourceId}/contracts/c/${contractUuid}/levels-of-service/los/${losUuid}`,
        { serviceName: 'trip' },
      )
      .then((res) => res.data),
  getContracts: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/contracts`, { ...options, serviceName: 'trip' })
      .then((res) => res.data),
  searchContracts: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/contracts/search`, {
        ...searchRetryConfig,
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  getContractEvents: (orgId, uuid, options) =>
    kinetikApi
      .get(`/${orgId}/contracts/c/${uuid}/events`, {
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  getAssignees: (orgId, options = {}) =>
    kinetikApi
      .get(`/${orgId}/contracts/assignees`, { ...options, serviceName: 'trip' })
      .then((res) => res.data),
  searchProviders: (orgId, options) =>
    kinetikApi
      .get(`/${orgId}/contracts/search`, {
        ...searchRetryConfig,
        ...options,
        serviceName: 'trip',
      })
      .then((res) => res.data),
  updateProviderContractLabels: (orgResourceId, contractUuid, payload) =>
    kinetikApi
      .patch(`/${orgResourceId}/contracts/c/${contractUuid}/labels`, payload, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
  updateContractStatus: (orgResourceId, contractUuid, payload) =>
    kinetikApi
      .patch(`/${orgResourceId}/contracts/c/${contractUuid}/status`, payload, {
        serviceName: 'trip',
      })
      .then((res) => res.data),
};
